<!--<nav class="pre-header display">

    <div class="container-fluid">
        <div class="container">
            <div class="row">
                <div class="col-lg-9">
                    <div class="row">
                        <div class="col-lg-6">
                            <i class="far fa-envelope "></i> <a href="mailto:office@downersgrovemotorsales.com" style="color:white;"><span class="small_font">&nbsp;office@downersgrovemotorsales.com </span></a>
                        </div>
                        <div class="col-lg-3">

                        </div>
                        <div class="col-lg-2 web">


                            <a href="https://www.facebook.com/profile.php?id=61554302522548&mibextid=nwBsNb" target="_blank" class="fab fa-facebook-f colr"></a>
                            &nbsp; | &nbsp;
                            <a href="https://www.instagram.com/accounts/login/" target="_blank" class="fab fa-instagram colr"></a>
                        </div>
                    </div>

                </div>
                <div class="col-lg-3 web1">
                    <span style="    margin-left: 25%;">
                        <i class="fa-solid fa-phone"></i>&nbsp; <a href="tel:9876543210" style="color:white;"><span class="small_font"> +1 877 4 999 2277</span></a>
                    </span>
                    &nbsp;<a href="https://www.facebook.com/profile.php?id=61554302522548&mibextid=nwBsNb" target="_blank" class="fab fa-facebook-f colr"></a>
                    &nbsp; | &nbsp;
                    <a href="https://www.instagram.com/accounts/login/" target="_blank" class="fab fa-instagram colr"></a>


                </div>
            </div>
        </div>

    </div>
</nav>

<nav class="navbar navbar-expand-lg navbar-light bg-light"
     [class.active]="classApplied"
     [ngClass]="{'sticky': isSticky}">

    <div class="container">
        <a class="navbar-brand" routerLink="/">
            <img src="assets/img/lo.jpeg" style="width: 65px;height:65px; border-radius: 50px;" />&nbsp;
            <span>S</span>ubhasankalpam <span>F</span>oundation<sub class="subtitle">A Thought for a Good Cause</sub>
        </a>
        <button class="navbar-toggler" type="button" (click)="toggleClass()" style="color:white;">
            <span class="burger-menu" style="color:white;">
                <span class="top-bar" style="color:white;"></span>
                <span class="middle-bar" style="color:white;"></span>
                <span class="bottom-bar" style="color:white;"></span>
            </span>
        </button>
        <div class="collapse navbar-collapse" id="navbarSupportedContent">
            <ul class="navbar-nav ml-auto web_nav">
                <li class="nav-item"><span class="nav-link" routerLink="/home">Home</span></li>
                <li class="nav-item"><span class="nav-link" routerLink="/about">About</span></li>
                <li class="nav-item"><span class="nav-link" routerLink="/donate">Donate</span></li>
                <li class="nav-item"><span class="nav-link" routerLink="/Blogs">Blogs</span></li>
                <li class="nav-item"><span class="nav-link" routerLink="/Gallery">Gallery</span></li>
                <li class="nav-item"><span class="nav-link" routerLink="/contact">Contact</span></li>
            </ul>
            <ul class="navbar-nav ml-auto for-responsive">
                <li class="nav-item"><span class="nav-link" (click)="home();">Home</span></li>
                <li class="nav-item"><span class="nav-link" routerLink="/about">About Us</span></li>
                <li class="nav-item"><span class="nav-link" (click)="donate();">Donate Now</span></li>
                <li class="nav-item"><span class="nav-link" (click)="Blogs();">Blogs</span></li>
                <li class="nav-item"><span class="nav-link" (click)="Gallery();">Gallery</span></li>
                <li class="nav-item"><span class="nav-link" routerLink="/contact">Contact Us</span></li>
            </ul>
        </div>
    </div>
</nav>-->
<nav class="top_nav">
    <div class="container-fluid">
        <div class="container">
            <div class="row"> 
                        <div class="col-lg-4">
                            <i class="far fa-envelope "style="color: white; margin-left: 9%;"></i>
                            <a href="mailto:Mail2subhasankalpam@gmail.com" target="_blank"style="color:white;">&nbsp; Mail2subhasankalpam@gmail.com</a>
                        </div>
                        <div class="col-lg-4">
                            <span>
                                <i class="fa-solid fa-phone"style="color:white;"></i>&nbsp; <a href="tel:8328080097" style="color:white;">
                                <span class="small_font"style="color:white;"> +91 8328080097&nbsp;/&nbsp;7794916299</span></a>
                            </span>
                        </div>
                <div class="col-lg-1"></div>
                        <div class="col-lg-3">
                           <a href="https://www.facebook.com/profile.php?id=100088499520137&mibextid=ZbWKwL" target="_blank" class="fab fa-facebook-f"></a>
                                <a href="https://www.instagram.com/subhasankalpamfoundation?igsh=MWgzMjZ1ZnBlMTNzdw==" target="_blank" class="fab fa-instagram"></a>
                                <a href="https://youtube.com/@subhasankalpam174?si=yqu1IxpZWQNQ-7WI" target="_blank" class="fab fa-youtube"></a>
                            
                        </div>
                    </div>

             
            </div>
        </div>

</nav>

<nav>
    <div class="navbar" [class.active]="classApplied" [ngClass]="{'sticky': isSticky}">
        <div class="container nav-container">
            <div class="logo">
                <img src="assets/img/lo.jpeg" class="mobile_text" style="width: 65px;height:65px; border-radius: 50px;" />&nbsp;
                <div class="mobile_bar">
                    <a class="navbar-brand" routerLink="/home-one">
                        <img src="assets/img/lo.jpeg" style="width: 65px;height:65px; border-radius: 50px;" />&nbsp;
                        <span>S</span>ubhasankalpam <span>F</span>oundation<sub class="subtitle">A Thought for a Good Cause</sub>
                    </a>
                </div>
            </div>
            <input class="checkbox" type="checkbox" name="" id="menuCheckbox" />

           

            <div class="hamburger-lines" style="color:white;">
                <span class="line line1" style="color:white;"></span>
                <span class="line line2" style="color:white;"></span>
                <span class="line line3" style="color:white;"></span>
            </div>

            <div class="menu-items">
                <ul>
                    <li class="nav-item"><span class="nav-link" (click)="closeMenuAndNavigate('/home-one')">Home</span></li>
                    <li class="nav-item"><span class="nav-link" (click)="closeMenuAndNavigate('/about')">About Us</span></li>
                    <li class="nav-item"><span class="nav-link" (click)="closeMenuAndNavigate('/')">Donate Now</span></li>
                    <li class="nav-item"><span class="nav-link" (click)="closeMenuAndNavigate('/Blogs')">Blogs</span></li>
                    <li class="nav-item"><span class="nav-link" (click)="closeMenuAndNavigate('/Gallery')">Gallery</span></li>
                    <li class="nav-item"><span class="nav-link" (click)="closeMenuAndNavigate('/contact')">Contact Us</span></li>
                </ul>
            </div>
        </div>
    </div>
</nav>
<script>
    function closeMenu() {
        document.getElementById('menuCheckbox').checked = false;
    }
</script>
<style>

    .subtitle {
        margin-left: -16rem;
    }
   /* .navbar-brand span {
        color: white;
        line-height: 10px;
        text-transform: lowercase;
        transition: var(--transition);
        font-size: 40px;
        font-weight: 700;
    }*/
    .hamburger-lines {
        display: block;
        height: 26px;
        width: 32px;
        position: absolute;
        top: 17px;
        right: 20px; /* Aligning to the right */
        z-index: 2;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
    }

    .nav-container {
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 62px;
    }
    .navbar .menu-items {
        display: flex;
    }

      .navbar .nav-container li {
        list-style: none;
    }

    .navbar .nav-container a {
        text-decoration: none;
        color: white;
        font-weight: 500;
        font-size: 1.2rem;
        padding: 0.7rem;
    }

        .navbar .nav-container a:hover {
            font-weight: bolder;
        }

    .nav-container {
        display: block;
        position: relative;
        height: 60px;
    }

        .nav-container .checkbox {
            position: absolute;
            display: block;
            height: 32px;
            width: 32px;
            top: 20px;
            right: 20px;
            z-index: 5;
            opacity: 0;
            cursor: pointer;
        }

        .nav-container .hamburger-lines {
            display: block;
            height: 26px;
            width: 32px;
/*            position: absolute;
*/            top: 17px;
/*            left: 20px;
*/            z-index: 2;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
        }

            .nav-container .hamburger-lines .line {
                display: block;
                height: 4px;
                width: 100%;
                border-radius: 10px;
                background: white;
            }

            .nav-container .hamburger-lines .line1 {
                transform-origin: 0% 0%;
                transition: transform 0.4s ease-in-out;
            }

            .nav-container .hamburger-lines .line2 {
                transition: transform 0.2s ease-in-out;
            }

            .nav-container .hamburger-lines .line3 {
                transform-origin: 0% 100%;
                transition: transform 0.4s ease-in-out;
            }


    .navbar .menu-items {
        padding: 15px;
        box-shadow: inset 0 0 2000px rgba(255, 255, 255, .5);
        height: 80vh;
        width: 30%;
        transform: translateX(135%); /* Initial position off-screen to the right */
        display: flex;
        flex-direction: column;
        position: absolute;
        top: 0;
        right: 0;
        margin-top: 62px; /* Adjusted to match the navbar height */
        padding-right: 35px;
        transition: transform 0.5s ease-in-out;
        text-align: left;
        background: white;
        color: black;
    }

  

        .navbar .menu-items li {
            margin-bottom: 1.2rem;
            font-weight: 500;
        }

    .logo {
        /*        position: absolute;
*/ top: 5px;
        right: 15px;
        font-size: 1.2rem;
        color: white;
    }
    .mobile_bar{
        display:contents;
    }
    .nav-container input[type="checkbox"]:checked ~ .menu-items {
        transform: translateX(0);
    }
       .nav-container input[type="checkbox"]:checked ~ .hamburger-lines .line1 {
        transform: rotate(45deg);
    }

    .nav-container input[type="checkbox"]:checked ~ .hamburger-lines .line2 {
        transform: scaleY(0);
    }

    .nav-container input[type="checkbox"]:checked ~ .hamburger-lines .line3 {
        transform: rotate(-45deg);
    }

    .nav-container input[type="checkbox"]:checked ~ .logo {
        display: none;
    }
    .mobile_text {
        display: none;
    }
    .top_nav {
        display: block;
        background: #008cb3;
        padding: 4px;
        border-bottom: 1px solid white;
        margin-bottom: 1px;
    }
    @media only screen and (max-width:600px) {
        .navbar .menu-items {
            padding-top: 46px;
            box-shadow: inset 0 0 2000px rgba(255, 255, 255, .5);
            height: 80vh;
            width: 65%;
            transform: translateX(135%);
            display: flex;
            flex-direction: column;
            position: absolute;
            top: 0;
            right: 0;
            margin-top: 62px;
            padding-right: 35px;
            transition: transform 0.5s ease-in-out;
            text-align: right;
            background: white;
            color: black;
        }
        .top_nav{
            display:none;
        }
        .mobile_text {
            display: block;
        }
        
        .mobile_bar {
            display: none;
        }
        .navbar {
            top: 0px;
            left: 0;
            z-index: 2;
            width: 100%;
            position: fixed !important;
            /* background: transparent !important; */
            background: #008cb3 !important;
            padding-top: 5px;
            padding-bottom: 12px;
        }
    }
</style>
